import Calculator from './Calculator';

const CalculationPage = () => <Calculator />;

export default CalculationPage;
